var map = {
	"./chameleon.svg": 7,
	"./cup.svg": 8,
	"./pie.svg": 9,
	"./roboAd.svg": 10,
	"./settings.svg": 11,
	"./settings2.svg": 12,
	"./sun.svg": 13,
	"./unlock.svg": 14
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;



//////////////////
// WEBPACK FOOTER
// ./~/.1.0.4@vue-svg-icon/svg ^\.\/.*\.svg$
// module id = 6
// module chunks = 1